import React from 'react';
import '../top.css';
import {Topbardata} from './TopbarData';

function TopBar() {
    return (
        <div className="Topo">
            <ul className="SidebarLis">
          
             {Topbardata.map((val,key)=>
             {
                 return <li key={key} className="ro" onClick={()=>window.location.pathname=val.link}>
       
                 <div id="icon">{val.icon}</div> 
                 <div id='name'>{localStorage.getItem('username')}</div>
                 </li>;
             }
             )}
            
             </ul>
        </div>
    )
}

export default TopBar
